/*跨域地址*/
let dev = process.env.dev;
dev = dev + "/c";
const wxlogin = process.env.wxlogin;
const cApi = process.env.cApi;
const brApi = process.env.brApi;

export default {
  /** 客户在微信公众号登录*/
  getUserToken: {
    url: cApi + "/kbc-ccs-dc/api/noauth/login/mp",
    method: "post",
    config: {
      showError: true,
    },
  },
  /**获取微信的token jsticket */
  getWechatToken: {
    url: cApi + "/kbc-ccs-dc/api/noauth/wechat/signature",
    method: "post",
    config: {
      closeLoading: true,
    },
  },
  //生成tokenByUnionId
  getTokenByUnionId: {
    url: cApi + "/kbc-ccs-dc/api/noauth/token",
    method: "get",
    config: {
      showError: true,
    },
  },
  /**发送短信 全局 */
  getSmsCode: {
    url: dev + "/noauth/sms/send",
    method: "post",
  },
  /**发送短信 登录 */
  getSmsCodeByLogin: {
    url: cApi + "/kbc-ccs-dc/api/canauth/sms/code/send",
    method: "post",
  },
  /**绑定手机号码（微信环境） */
  wxBind: {
    url: cApi + "/kbc-ccs-dc/api/canauth/register/phone",
    method: "post",
  },
  //创建子渠道并返回渠道二维码- 付费项目的二维码
  createQrcode: {
    url: brApi + "/c/noauth/qrcode/subscribe",
    method: "post",
  },
  //新的创建二维码不带渠道id
  createQrcodeByform: {
    url: brApi + "/c/noauth/qrcode/subscribe",
    method: "post",
  },
  //获取子渠道投放二维码
  createQrcodeSubscribe: {
    url: brApi + "/c/noauth/qrcode/subscribe",
    method: "post",
  },
  //微信用户信息
  getWxInfo: {
    url: cApi + "/kbc-ccs-dc/api/wechat/info",
    method: "get",
    config: {
      showError: true,
    },
  },
  //token 换 code
  getCodeByToken: {
    url: cApi + "/kbc-ccs-dc/api/wechat/code",
    method: "get",
  },
  /** 获取托管、服务、粉丝关系代理人ID*/
  getAgentId: {
    url: dev + "/agent/relationship",
    method: "get",
  },
  //发送验证码
  getGeeCode: {
    url: dev + "/noauth/sms/code",
    method: "post",
  },
  //滑动验证码
  getSmsCodeActivity: {
    url: dev + "/noauth/captcha",
    method: "get",
  },
  /**获取用户信息 */
  getCustDetails: {
    url: cApi + "/kbc-ccs-dc/api/wechat/info",
    method: "get",
    config: {
      closeLoading: true,
    },
  },
  /**查询手机号是否已绑定 */
  checkPhone: {
    url: cApi + "/kbc-ccs-dc/api/noauth/phone/register/flag",
    method: "get",
    config: {
      closeLoading: true,
    },
  },
  /**绑定/更换手机号 */
  changePhone: {
    url: cApi + "/kbc-ccs-dc/api/user/change/phone",
    method: "post",
  },
  //获取用户基本信息
  getCostomerInfo: {
    url: cApi + "/kbc-pmc/api/customer/info",
    method: "get",
  },
  /** 删除OSS问题图片 */
  delQuesImg: {
    url: dev + "/sv/question/img",
    method: "delete",
  },
  //是否实名制
  getRealName: {
    url: cApi + "/kbc-ccs-dc/api/card/real/name/info",
    method: "get",
  },
  //实名制证件号
  getIndexRealInfo: {
    url: dev + "/index/new/real/info",
    method: "get",
  },
  // 创建用户分享行为 app
  saveShareBehaviorByApp: {
    url: cApi + "/kbc-pmc/api/data/flow/app/behavior",
    method: "post",
    config: {
      closeLoading: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/api/service.js